import { render, staticRenderFns } from "./zxwzBanKuai.vue?vue&type=template&id=29cc6151&scoped=true"
import script from "./zxwzBanKuai.vue?vue&type=script&lang=js"
export * from "./zxwzBanKuai.vue?vue&type=script&lang=js"
import style0 from "./zxwzBanKuai.vue?vue&type=style&index=0&id=29cc6151&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc6151",
  null
  
)

export default component.exports